import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tableContainer: {
      borderRadius: 0,
    },

    table: {
      '& th:first-child': {
        // borderTopLeftRadius: '1rem',
      },
      '& th:last-child': {
        borderTopRightRadius: '1rem',
      },
      '& tr:last-child ': {
        '& td:first-child': { borderBottomLeftRadius: '1rem' },
        '& td:last-child': { borderBottomRightRadius: '1rem' },
      },

      '& table': {
        borderRadius: '1rem',
        marginBottom: '2rem',
      },
      '& thead': {
        background: '#14171A',
        borderRadius: '1rem 1rem 0px 0px',
      },
      '& thead th': {
        color: '#fff',
        borderBottom: 'none',
      },
      '& thead tr > *': {
        padding: '0.5rem 1rem',
        fontSize: '0.8rem',
      },
      '& tbody tr > *': {
        padding: '0.5rem 1rem',
        fontSize: '0.8rem',
      },
      '& td': {
        borderBottom: 'none',
      },
      '& tbody tr:nth-of-type(odd) ': {
        background: '#fff',
      },
      '& tbody tr:nth-of-type(even)': {
        background: '#F5F8FA',
      },
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: '1.25rem',
      width: 1,
    },
    sortLabel: {
      color: '#fff !important',
    },
  }),
);

export default useStyles;
